import { Input, DatePicker, Select, Modal } from "antd";
import styled, { keyframes } from "styled-components";

export const ModalOverlayHeader = styled.div`
  position:  ${({ mudarStyle }) => mudarStyle ? 'relative' : 'fixed'};
  width: ${({ mudarStyle }) => mudarStyle ? '100%' : '100vw'};
  height: ${({ mudarStyle }) => mudarStyle ? 'auto' : '2000vw'}; /*1000px*/
  top: ${({ mudarStyle }) => mudarStyle ? '-580px' : '0'};
  left: 0;
  z-index: 1000;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease, visibility 0.5s ease;
`;

export const ModalWrapper = styled.div`
   background-color: #fff;
  border-radius: 4px;
  box-shadow: rgba(33, 35, 38, 0.1) 2px 10px 10px -10px;
  width: auto;
  max-height: auto;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  position: absolute;
  z-index: 2;
  top: 45%;
  left: 50%;
  backdrop-filter: none;
  transform: translate(-50%, -45%); /* Centraliza o modal */
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  
  .icon-font-center{
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 21px;
  }

   &.minimized {
    width: 300px;
    height: 0;
    position: sticky;
    top: 500px;

    .overflow-hidden{
     overflow: hidden;
    }
  }

  .container {
    font-size: 14px;
    padding: 10px 0 10px;


    .font-strong{
    color:#343434;
    }
  }

  .font{
  font-size: 16px;
    color: #005a9e;
  }

  .padding-10-container {
    padding: 10px;
  }

  .padding-5 {
    padding: 5px 0;
  }
    .paddg-5{
     padding: 5px;
    }

  .bg-color{
  background: #005a9e;
  color:#fff;
  }

  .style{
      color: #787676;
    font-size: 14px;
    margin: 10px;
  }

  .bgf5f5f5{
      background-color: #f5f5f5;
  border: 1px solid #ddd !important;
  padding:10px;
      border-radius: 4px;
  }

  .barra {
    background: #005a9e;
    color: #fff;
    font-size: 16px;
    border-radius: 4px 0 0 0;
  }

  .display-flex {
    display: flex;
  }

  .rev-border-bg{
  background: none;
    border: none;
    cursor:pointer;
  }

  .disabled-btn{
    cursor:not-allowed;
    opacity: 0.5;
  }

  .title {
    width: 100%;
    display:flex;
  }

  .btn-close {
    padding: 10px;
  }

  .close {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }

  .margin-0-auto{
  margin: 0 auto
  width: 40px;
  }

  .button-container {
  padding-top: 20px;
  text-align: right;
}

.bg-color {
  background-color: #005a9e;
  color: white;
}

.scroll-Y {
  max-height: 300px; /* ou ajuste como quiser */
  overflow-y: auto;
}

.table-obs{
    width: 500px;
    font-size: 13px;
    border-radius: 4px;
    margin: 5px;
    padding: 10px;
    background: #fff;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

    .title-obs{
    color: #005a9e;
    }

    .observacao{
    color: #6e6e6e;
    }

    .margin-btn{
    margin-bottom: 10px;
    }

    .justify-btn{
        display: flex;
    justify-content: right;
    }

    .btn-editar-y{
    background:#ffca2e;
    color:#fff;
    border:none;
    }

    .btn-editar-y:hover{
    background:#ffca2e;
    color:#fff;
    }
}
    .outras-obs{
    width: 500px;
    background-color: rgb(247 247 247);
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 12px;
    font-size: 13px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    color: #626262;
    margin: 5px;
    }
`;

export const ModalService = styled(Modal)`

  border-radius: 4px;

  width: auto;
  max-height: auto;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  position: absolute;
  z-index: 2;
  top: 40%;
  left: 50%;
  backdrop-filter: none;
  transform: translate(-50%, -45%); /* Centraliza o modal */

  .center-component{
      display: flex;
    margin: 5px;
  }
    .fontS-32{
    font-size: 32px;
    }

  .icon-font-center{
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 21px;
  }

   &.minimized {
    width: 300px;
    height: 0;
    position: sticky;
    top: 500px;

    .overflow-hidden{
     overflow: hidden;
    }
  }

  .container {
    font-size: 14px;
    padding: 10px 0 10px;


    .font-strong{
    color:#343434;
    }
  }

  .font{
  font-size: 16px;
    color: #005a9e;
  }

  .padding-10-container {
    padding: 10px;
  }

  .padding-5 {
    padding: 5px 0;
  }
    .paddg-5{
     padding: 5px;
    }

  .bg-color{
  background: #005a9e;
  color:#fff;
  }

  .style{
      color: #787676;
    font-size: 14px;
    margin: 10px;
  }

  .bgf5f5f5{
      background-color: #f5f5f5;
  border: 1px solid #ddd !important;
  padding:10px;
      border-radius: 4px;
  }

  .barra {
    background: #005a9e;
    color: #fff;
    font-size: 16px;
    border-radius: 4px 0 0 0;
  }

  .barraJSON {
    background:#faad14;
    color: #fff;
    font-size: 16px;
    border-radius: 4px 0 0 0;
  }

  .display-flex {
    display: flex;
  }

  .rev-border-bg{
  background: none;
    border: none;
    cursor:pointer;
  }

  .disabled-btn{
    cursor:not-allowed;
    opacity: 0.5;
  }

  .title {
    width: 100%;
    display:flex;
  }

  .btn-close {
    padding: 10px;
  }

  .close {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }

  .margin-0-auto{
  margin: 0 auto
  width: 40px;
  }

  .float{
  text-align:right;
  }

  .color{
  background: #005a9e;
  }

  .with-100-por{
  width: 100%;
  }

  .fontSize{
  font-size:18px;
  }
  .cursor{
  cursor: pointer;
  }



        textarea{
  width:400px;
  height: 100px;
  padding: 10px;
  margin:10px;
  color:#787878;
      font-family: Nunito, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .centralizar{
      margin: 0 auto;
  }

  .right{
      text-align: right;
  }

  .qr-code{
  width: 130px;
    padding: 10px;
    margin: 10px;
    border-radius: 4px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    background: #fff;
  }

  .valor{
  text-align:center;
  padding:10px;
  font-size: 24px;
    color: #6a6a6a;
    font-weight: 100;
  }

  .icon-pix{
      font-size: 24px;
    margin: 5px;
  }

.instructions {
  padding-bottom: 20px;
}

.select {
  width: 100%;
  padding: 10px 0;
}

.width-select {
  width: 100%;
}

.button-container {
  padding-top: 20px;
  text-align: right;
}

.bg-color {
  background-color: #005a9e;
  color: white;
}

.marginBottom-15{
margin-bottom: 15px;
}

.margin-bottom-5{
margin-bottom: 5px;
}

.padding-20{
padding:20px;
}

.margin-5{
margin:5px;
}

.font-size-14{
font-size:14px;
}

.text-align-right{
text-align: right;
}

.margin-0-5{
margin: 0 5px;
}


.steps-vertical {
  padding: 10px;
  height: 300px;
  width: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

/* Estilo para navegadores baseados em WebKit (como Chrome, Edge e Safari) */
.steps-vertical::-webkit-scrollbar {
  width: 8px; /* Largura da scrollbar */
}

.steps-vertical::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.steps-vertical::-webkit-scrollbar-track {
  background-color: transparent;
}


`;

export const Maxmized = styled.div`
  /* Centralizar modal */
  position: fixed;
  z-index: 2;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -45%); /* Centraliza o modal */
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

 /* Estilos para estado normal */


  /* Estilos para estado minimizado */
  &.minimized {
    bottom: 0;
    left: 400px;
    top: 505px;
    transform: none;
    width: 300px;
    height: 50px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    cursor: pointer;
    background: #005a9e;
  }
`;

export const ModalContainerEditar = styled.div`
  .barra {
    paddin: 10px;
    background: #005a9e;
  }
`;

export const ModalContainer = styled.div`
  background-color: #ffffffff;
  transform: translate(3%, 5%);
  width: 98%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column; /* Garantir que o conteúdo se organize em coluna */
  position: relative;

  right: 31px;
  top: -50px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: var(--scrollbar-track-color, #f1f1f1);
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb-color, #c4c4c4);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover-color, #555);
  }

  .main {
    display: flex;
  }
  .controlers {
    width: 5%;
    border-radius: 0;
  }

  .bg-pramary{
    background: #005a9e;
  }
    .bg-white{
    background:rgb(255, 255, 255);
    }

  .modalOS {
    width: 100%;
  }

  .cor-comercial{
      background: #faad14 !important;
    color: #fff !important;
  }

  .btn-disabled{
 background-color: #f7f7f7; /* Cinza claro */
  cursor: not-allowed;
  color: #999; /* Ajuste de cor do texto para combinar */
  }

  .btnOS {
    width: 80%;
    height: 50px;
    margin: 10px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
    border: none;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  }
  .btnOS:hover {
    cursor:pointer;
    container-type: size;
    padding:3px;
    color: #ffffffff;
    background: #005a9e;
  }

  .btnOS-imports {
    width: 80%;
    height: 50px;
    margin: 10px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
    border: none;
    color: #5c5c5c;
    background: #ffffff;
  }

  .btnOS-imports:hover {
  cursor:pointer;
    container-type: size;
    padding:3px;
    color: #ffffffff;
    background: #005a9e;

  }

  .font-icon {
    font-size: 25px;
  }
  .bg-color-white {
    color: #5c5c5c;
    background: #ffffff;
  }

  .btn-bg-color-chat{
    color: #fff;
    background: #005a9e;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }

  .bg-color-yellow {
    background: #faad14;
    color: #fff;
    border-radius: 50%;
  }

  .bg-color-red {
    background: #fb4b4b;
    color: #fff;
    border-radius: 50%;
  }

  .displayFlex {
    display: flex;
    background: #005a9e;
    border-radius: 8px 8px 0px 0px;
    color: #fff;
  }

  .padding10 {
    padding: 10px;
  }

  .margin-auto {
    margin: 0 auto;
  }

  .styled-label {
    font-size: 24px;
    color: #a7a7a7;
  }

  .btn-close,
  .title {
    padding: 10px;
  }

  .title {
    width: 100%;
  }

  .close {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }

  .modal-title {
    font-size: 20px;
    padding: 10px;
  }

  .title {
    span {
      position: relative;
      top: 10px;
    }
  }

  .margin-0-auto {
    width: 40px;
    margin: 0 auto;
    padding: 10px;
  }

  .text-align {
    text-align: center;
  }

  .formImgProcess{
    width:60px;
    height:60px;
    font-size: 30px;
  }

  .containt-modal{
    display: flex;
    flexWrap: wrap;
    justifyContent: center;
    alignItems: center;
    gap: 10px;
    maxWidth: 90%;
  }

  .justifyContent{
    width: 100%; 
    display: flex; 
    justify-content: center;
  }

  .width-margin{
    /**width:80%; */
    margin: 0 auto;
  }
`;

export const SkeletonProcessos= styled.div`
width:700px;
margin: 0 auto;
padding:10px;
`;

export const ComponentInfo = styled.div`
  padding: 10px;

  .btn-icon {
    width: 40px;
    height: 40px;
    padding: 8px;
    font-size: 18px;
    background: #005a9e;
    color: #fff;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    cursor: pointer;
  }

  .tituloQSA {
    padding: 10px 0;
    color: #999999;
    font-size: 16px;
  }

  .DisplayFlex {
    display: flex;
    padding: 10px;
    width: 98%;
    margin: 0 auto;
  }

  .position-left-12 {
    position: relative;
    left: 12px;
  }

  .titulo {
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    color: #0071e3;
    justify-content: left;
    display: flex;
    align-items: center;
  }

  .btn-Add {
    width: 100%;
    text-align: right;
  }

  .card-doc {
    width: 90%;
    padding: 30px;
    margin: 0 auto;
    border-radius: 6px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    background: #fff;
    margin-bottom: 20px;
    border-left: 3px solid #919191;
    color: #8e8e8e;
  }

  .display-flex {
    display: flex;
  }

  .name-file {
    width: 80%;

    span {
      position: relative;
      top: 10px;
    }
  }

  .btn-action {
    margin: 0 0 0 10px;
  }

  .color {
    background: #005a9e;
  }

  .float-btn {
    padding: 10px;
    text-align: right;
  }

  .alert-message {
    padding: 10px;
    width: 90.5%;
    margin: 0 auto;
  }

  .icon-font {
    font-size: 28px;
    position: relative;
    top: 0px;
    margin-right: 10px;
  }

  .icon-sucess {
    position: relative;
    top: 9px;
    margin-right: 10px;

    width: 23px;
    height: 20px;
    padding: 1px;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    position: relative;
    border-radius: 7px;
    background: #52b709;
    color: #fff;
}

  .files {
    display: flex;
  }

  .style-bkg-white {
    border: 1px solid rgb(233, 233, 233);
  }

  .style-bkg {
    background: #ffffff;
    color: #4e4e4e;
    margin: 5px;
    border: 1px solid #cacaca;
  }

  .style-bkg-word {
       background: #e8f0fe;
    color: #2b579a;
        border: 1px solid #b1bfd4;
    margin: 5px;
  }


  .style-bkg-pdf {
       background: #ffebeb;
    color: #d93025;
        border: 1px solid #f6c8c8;


    margin: 5px;
  }

  .style-bkg-cnpj{
     background: #e8f0fe;
    color: #2b579a;
        border: 1px solid #b1bfd4;
    margin: 5px;
  }

  .style-bkg-im{
     background: #e8f0fe;
     color: #2b579a;
        border: 1px solid #b1bfd4;
    margin: 5px;}

  .line-table {
    padding: 0px;
    width: 55%;
    display: flex;
    justify-content: left;
    text-align: left;
    align-items: center;
  }

  .just-center {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .format-file {
    padding: 0px 10px;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .border {
    width: 100%;
    padding: 10px;
  }

  .button {
    background-color: #fff;
    color: #6f6e6e;
    padding: 10px 13px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    transition: background-color 0.3s ease;
    margin-bottom: 10px;
    margin-right: 6px;
  }

  .float-buttons {
    display: flex;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .format-btn {
    margin: 10px 5px 0px;
  }
`;

export const CustmInput = styled(Input)`
&&[disabled] {
    color:rgb(0, 0, 0) !important;
    background-color: #f0f0f0 !important;
  }
`;

export const CustmSelect = styled(Select)`
 &&.ant-select-disabled .ant-select-selector {
    color: rgb(0, 0, 0) !important;
    background-color: #f0f0f0 !important;
    border-color: #ccc !important;
  }
`;

export const CustmDatePicker = styled(DatePicker)`
&& .ant-picker-input > input[disabled] {
    color:rgb(0, 0, 0) !important;
  }

  &&[disabled] {
    background-color: #f0f0f0 !important;
    border-color: #ccc !important;
  }
`;

export const ComponentInput = styled.div`
  margin: 0 10px;

  p {
    font-size: 14px;
  }
`; 

export const ComponentLine = styled.div`
  display: flex;


  .cont-btn{
      display: flex;
    justify-content: center;
    align-items: end;
  }


  .btn-import-document {
    width: 40px;
    height: 40px;
    padding: 8px;
    font-size: 22px;
    background: #005a9e;
    color: #fff;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    cursor: pointer;
    border: none;

    opacity: 0;
    visibility: hidden;
    transform: scale(0.8) translateY(10px);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    pointer-events: none;
}

.btn-import-document.show {
    opacity: 1;
    visibility: visible;
    transform: scale(1) translateY(0);
    pointer-events: auto;
}

.btn-import-document:active {
    background-color: #91caff;
    transform: scale(0.95);
}

`;


// Animação de "sombra se movendo"
const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

// Container do Skeleton Circular
export const SkeletonCircle = styled.div`
  width: 50px; /* Tamanho personalizável */
  height: 50px;
  border-radius: 50%;
  background: #e0e0e0;
  position: relative;
  overflow: hidden;
`;

// Efeito de animação da sombra
export const ShimmerEffect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  animation: ${shimmer} 1.5s infinite;
`;


export const ComponentJustifyContentDisplayFlex = styled.div`
display:flex;
justify-content:center;
`;